import { KeyString, Option } from 'types'

export const UNIFIED_PERSON_REQUIRED_FIELDS_FOR_SERVICE_REQUEST: Option[] = [
  {
    label: 'Nome',
    value: 'name',
  },
  {
    label: 'Nome da mãe',
    value: 'mother_name',
  },
  {
    label: 'Nome do Pai',
    value: 'father_name',
  },
  {
    label: 'CNS',
    value: 'cns_number',
  },
  {
    label: 'CPF',
    value: 'cpf_number',
  },
  {
    label: 'RG',
    value: 'rg_number',
  },
]

export const UNIFIED_PERSON_REQUIRED_FIELDS_FOR_SERVICE_REQUEST_OBJECT: KeyString = {
  name: 'Nome',
  mother_name: 'Nome da mãe',
  father_name: 'Nome do Pai',
  cns_number: 'CNS',
  cpf_number: 'CPF',
  rg_number: 'RG',
}
